import { useQuery } from '@tanstack/react-query';
import { instance } from '@configs';

import { IResponse } from '@types';
import { getToken } from '@utils';

import { CheckoutQueryKeys, EndpointsCheckoutQueryRotes } from './constants';
import { ICheckout, IEnterAmmount, IGetGates } from './types';

export const useGetCheckoutQuery = () => {
  return useQuery({
    queryFn: async (): Promise<ICheckout> => {
      const { data } = await instance.get<IResponse<ICheckout>>(
        EndpointsCheckoutQueryRotes.Checkout
      );
      return data.payload;
    },
    queryKey: [CheckoutQueryKeys.Checkout],
    enabled: Boolean(getToken()),
  });
};

export const useGetTokenizeCheckoutQuery = () => {
  return useQuery({
    queryFn: async (): Promise<ICheckout> => {
      const { data } = await instance.get<IResponse<ICheckout>>(
        EndpointsCheckoutQueryRotes.TokenizeCheckout
      );
      return data.payload;
    },
    queryKey: [CheckoutQueryKeys.TokenizeCheckout],
  });
};

export const useGetGatesQuery = (param: string) => {
  return useQuery({
    enabled: Boolean(param),
    queryKey: [CheckoutQueryKeys.GateAndDefaultGate, param],
    queryFn: async () => {
      const { data } = await instance.get<IGetGates>(
        `${EndpointsCheckoutQueryRotes.GateAndDefaultGate}/${param}`
      );
      return data;
    },
  });
};

export const useGetEnterAmountQuery = (param: string) => {
  return useQuery({
    enabled: Boolean(param),
    queryKey: [CheckoutQueryKeys.EnterAmount, param],
    queryFn: async () => {
      const { data } = await instance.get<IEnterAmmount>(
        `${EndpointsCheckoutQueryRotes.EnterAmount}/${param}`
      );
      return data;
    },
  });
};
